import { DeleteQuestionnaireQuestionBulkDocument } from '@/api/queries';
import { DeleteQuestionnaireQuestionBulkInput } from '@/models/gen/graphql';
import graphApi from '@/api';

const [runDeleteQuestion] = graphApi(DeleteQuestionnaireQuestionBulkDocument);

export const deleteQuestion = async (ids: string[]) => {
  const input: DeleteQuestionnaireQuestionBulkInput = { search: ids.map((id) => ({ id })) };
  return await runDeleteQuestion({ input });
};

export default deleteQuestion;
